import type { EnumUnion } from '@dresscode-frontend/utility-types';
import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';
import { StorageService, STORAGE_DRIVE_TYPE_VALUES } from '@/routes/_staff/storage-files/_list/-shared/-constants';
export const Columns = {
  NAME: 'NAME',
  PATH: 'PATH',
  USERS: 'USERS',
  OWNER: 'OWNER'
} as const;
export type Columns = EnumUnion<typeof Columns>;

/** APIがサポートするソートカラム */
const SortableColumns = {
  NAME: 'NAME',
  PATH: 'PATH',
  OWNER: 'OWNER',
  CREATED_TIME: 'CREATED_TIME',
  LAST_MODIFIED_TIME: 'LAST_MODIFIED_TIME'
} as const;
export const SearchSchema = z.object({
  // jsurl2 は `?storageService=GOOGLE_DRIVE` 形式で `_` をスペースに変換する
  // NOTE: これ他のところ起きてないのかな、共通化も検討
  storageService: z.preprocess(val => typeof val === 'string' ? val.replace(/ /g, '_') : val, z.nativeEnum(StorageService)).optional().default(StorageService.BOX),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  freeText: z.string().optional(),
  parentFolderIdIn: z.array(z.string()).optional(),
  driveType: z.enum(STORAGE_DRIVE_TYPE_VALUES).optional().default('SHARED'),
  driveIds: z.array(z.string()).optional(),
  sortColumn: z.nativeEnum(SortableColumns).optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional()
});
export type SearchSchema = z.infer<typeof SearchSchema>;